import _ from "lodash";

// helper function for search the whole object
const isMatchingSearch = function (items, query) {
  return Object.keys(
    _.pickBy(items, (item) => {
      if (
        typeof item !== "object" &&
        `${item}`.toLowerCase().includes(query.toLowerCase())
      ) {
        return true;
      } else if (typeof item === "object") return isMatchingSearch(item, query);
    })
  ).length;
};

export const campaigns = {
  // state
  state: {
    campaigns: [],
    selectedCampaign: null,
    campaignReceivers: null,
    templateMessages: [],
    templateMessageSettings: {},
    selectedTemplateMessage: null,
    receivers: [],
    selectedReceiver: null,
    campaignsPagination: {
      receivers: {},
      page: 1,
      per_page: 10,
      total: 0,
    },
  },

  // getters
  getters: {
    "campaigns/query": (state) => (query) => {
      const fallback = [];
      if (!state.campaigns || !state.campaigns.length) return fallback;
      const result = state.campaigns.filter((campaign) =>
        isMatchingSearch(campaign, query)
      );
      return _.orderBy(
        result && result.length ? result : fallback,
        ["created_at"],
        ["desc"]
      );
    },
    "templatemessages/query": (state) => (query) => {
      const fallback = [];

      if (!state.templateMessages || !state.templateMessages.length)
        return fallback;
      const result = state.templateMessages.filter((templateMessage) =>
        isMatchingSearch(templateMessage, query)
      );
      return result && result.length ? result.reverse() : fallback;
    },
    "receivers/query": (state) => (query) => {
      const fallback = [];
      if (
        !state.receivers ||
        !state.receivers.receivers ||
        !state.receivers.receivers.length
      )
        return fallback;
      const result = state.receivers.receivers.filter((receiver) =>
        isMatchingSearch(receiver, query)
      );
      return result && result.length ? result.reverse() : fallback;
    },
  },

  // mutations
  mutations: {
    "campaigns/add": function (state, data) {
      state.campaigns.splice(0, 0, data);
    },
    "campaigns/set": function (state, data) {
      state.campaigns = data;
    },
    "campaigns/pagination/set"(state, meta) {
      state.campaignsPagination = { ...state.campaignsPagination, ...meta };
    },
    "campaigns/select": function (state, data) {
      state.selectedCampaign = data;
    },
    "campaigns/select/recievers": function (state, data) {
      state.campaignReceivers = data;
    },
    "campaigns/select/recievers/pagination": function (state, data) {
      state.campaignsPagination.receivers = data;
    },
    "templatemessages/add": function (state, data) {
      state.templateMessages.splice(0, 0, data);
    },
    "templatemessages/set": function (state, data) {
      state.templateMessages = data;
    },
    "templatesettings/set": function (state, data) {
      state.templateMessageSettings = data;
    },
    "templatemessages/select": function (state, data) {
      state.selectedtemplateMessages = data;
    },
    "receivers/add": function (state, data) {
      state.receivers.splice(0, 0, data);
    },
    "receivers/set": function (state, data) {
      state.receivers = data;
    },
    "receivers/select": function (state, data) {
      state.selectedCampaign = data;
    },
    "receivers/select/recievers": function (state, data) {
      state.receiverReceivers = data;
    },
  },

  // actions
  actions: {
    // Campaigns CRUD
    "campaigns/get": async function (
      { commit, dispatch, getters },
      params = {}
    ) {
      try {
        const botId = getters["bot/id"];
        if (!botId) return false;
        dispatch("setLoader", true);
        const defaults = { page: 1, per_page: 10 };
        const query = {
          ...defaults,
          ...params,
          "filter[bot_id]": botId,
          "filter[q]": params.q,
        };
        const { data } = await this._vm.$http_session_manager({
          method: "get",
          params: query,
          url: "/campaigns",
        });
        commit("campaigns/set", data.campaigns);
        commit("campaigns/pagination/set", {
          page: data.page,
          per_page: data.per_page,
          total: data.count,
        });

        return data;
      } catch (err) {
        commit("campaigns/set", []);
        throw err;
      }
    },
    "campaigns/get/current": async function ({ commit }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.get(
          `/campaigns/${payload}`
        );
        const result = data;
        commit("campaigns/select", result);
        return result;
      } catch (err) {
        commit("campaigns/select", null);
        throw err;
      }
    },
    "campaigns/get/current/receivers": async function ({ commit }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.get(
          `/campaigns/${payload}/receivers`
        );
        const result = data;
        commit("campaigns/select/recievers", result);
        return result;
      } catch (err) {
        commit("campaigns/select/recievers", null);
        throw err;
      }
    },
    "campaigns/add": async function ({ dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.post(
          "/campaigns",
          payload
        );
        dispatch("campaigns/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "campaigns/update": async function ({ dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.put(
          `/campaigns/${payload.id}/update`,
          {
            name: payload.name,
          }
        );
        dispatch("campaigns/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "campaigns/delete": async function ({}, id) {
      try {
        await this._vm.$http_session_manager.delete(`/campaigns/${id}`);
        return true;
      } catch (err) {
        throw err;
      }
    },
    "campaigns/publish": async function ({ dispatch, state }) {
      try {
        dispatch("setLoader", true);
        await this._vm.$http_session_manager.post(
          `/campaigns/${state.selectedCampaign.id}/publish`
        );
        dispatch("setLoader", false);
        return true;
      } catch (err) {
        dispatch("setLoader", false);
        if (err.response.status === 400)
          dispatch("setErrorMessage", "You must train your campaign first");
        throw err;
      }
    },
    "campaigns/delete/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_session_manager.delete(`/campaigns/${id}`);
        dispatch("campaigns/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "campaigns/sync/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_session_manager.post(`/campaigns/${id}/sync`);
        dispatch("campaigns/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "campaigns/delete/multiple": async function ({ dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("campaigns/delete", payload[i].id);
          } catch (err) {
            dispatch("setLoader", false);
            throw err;
          }
          if (i === payload.length - 1) return dispatch("campaigns/get");
        }
      } catch (err) {
        throw err;
      }
    },
    "campaigns/set": function ({ commit }, data) {
      commit("campaigns/set", data);
      return data;
    },
    "campaigns/select": function ({ commit }, data) {
      commit("campaigns/select", data);
    },

    // Template Message CRUD
    "templatemessages/get": async function ({ commit, dispatch, getters }) {
      try {
        const botId = getters["bot/id"];
        if (!botId) return false;

        const { data } = await this._vm.$http_session_manager({
          method: "get",
          url: "/template-message",
          params: { "filter[bot]": botId, per_page: 5000 },
        });

        const { message, templateMessages } = data;
        commit("templatemessages/set", templateMessages);

        if (message) {
          dispatch("setSnackbar", {
            text: message,
            color: "warning",
            timeout: 15000,
          });
        }

        return templateMessages;
      } catch (err) {
        commit("templatemessages/set", []);
        throw err;
      }
    },
    "templatesettings/get": async function ({ commit, dispatch, getters }) {
      try {
        const botId = getters["bot/id"];
        if (!botId) return false;
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_session_manager({
          method: "get",
          url: "/template-message/settings",
        });
        dispatch("setLoader", false);
        const templateSettings = data;
        commit("templatesettings/set", templateSettings);

        return templateSettings;
      } catch (err) {
        commit("templatesettings/set", []);
        throw err;
      }
    },
    "templatemessages/get/current": async function ({ commit }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.get(
          `/template-message/${payload}`
        );
        const result = data;
        commit("templatemessages/select", result);
        return result;
      } catch (err) {
        commit("templatemessages/select", null);
        throw err;
      }
    },
    "templatemessages/add": async function ({ dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.post(
          "/template-message",
          payload
        );
        dispatch("templatemessages/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "templatemessages/update": async function ({ dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_session_manager.put(
          `/template-message/${payload.id}/update`,
          {
            name: payload.name,
          }
        );
        dispatch("templatemessages/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "templatemessages/delete": async function ({}, id) {
      try {
        await this._vm.$http_session_manager.delete(`/template-message/${id}`);
        return true;
      } catch (err) {
        throw err;
      }
    },
    "templatemessages/delete/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_session_manager.delete(`/template-message/${id}`);
        dispatch("templatemessages/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "templatemessages/delete/multiple": async function ({ dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("templatemessages/delete", payload[i].id);
          } catch (err) {
            dispatch("setLoader", false);
            throw err;
          }
          if (i === payload.length - 1) return dispatch("templatemessages/get");
        }
      } catch (err) {
        throw err;
      }
    },
    "templatemessages/set": function ({ commit }, data) {
      commit("templatemessages/set", data);
      return data;
    },
    "templatemessages/select": function ({ commit }, data) {
      commit("templatemessages/select", data);
    },
    "templatemessages/sync": async function (
      { commit, dispatch, getters },
      force
    ) {
      try {
        const botId = getters["bot/id"];
        if (!botId) return false;

        const { data } = await this._vm.$http_session_manager.post(
          "/template-message/sync",
          {
            bot_id: botId,
          },
          {
            params: {
              force,
            },
          }
        );

        if (data.message) {
          dispatch("setSnackbar", {
            text: data.message,
            color: data.sync ? "success" : "warning",
            timeout: 10000,
          });
        }
        return data;
      } catch (err) {
        commit("templatemessages/set", []);
        throw err;
      }
    },

    // Receivers CRUD
    "receivers/get": async function ({ commit, dispatch, state }, args) {
      try {
        const payload = args || {};
        const params = _.omit(payload, ["hideLoading", "id"]);
        const hideLoading = payload && payload.hideLoading;
        if (!hideLoading) {
          dispatch("setLoader", true);
        }
        let campaignId = null;
        if (!payload.id) {
          if (!state.selectedCampaign) {
            throw new Error("No Campaign Selected");
          }
          campaignId = state.selectedCampaign._id;
          if (!campaignId) {
            throw new Error("No Campaign Selected");
          }
        } else campaignId = payload.id;
        const { data } = await this._vm.$http_session_manager({
          method: "get",
          url: `/campaigns/${campaignId}/receivers`,
          params,
        });
        if (!hideLoading) {
          dispatch("setLoader", false);
        }
        const receivers = data;
        commit("receivers/set", receivers);
        commit(
          "campaigns/select/recievers/pagination",
          _.omit(data, ["receivers"])
        );
        return receivers;
      } catch (err) {
        commit("receivers/set", []);
        throw err;
      }
    },
    "receivers/get/current": async function ({ commit, dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_session_manager.get(
          `/receivers/${payload}`
        );
        dispatch("setLoader", false);
        const result = data;
        commit("receivers/select", result);
        return result;
      } catch (err) {
        commit("receivers/select", null);
        throw err;
      }
    },
    "receivers/get/current/receivers": async function (
      { commit, dispatch },
      payload = {}
    ) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_session_manager.get(
          `/campaign/${payload}/receivers`
        );
        dispatch("setLoader", false);
        const result = data;
        commit("receivers/select", result);
        return result;
      } catch (err) {
        commit("receivers/select", null);
        throw err;
      }
    },
    "receivers/add": async function ({ dispatch, state }, payload) {
      try {
        const campaignId = state.selectedCampaign._id;
        if (!campaignId) {
          throw new Error("No Campaign Selected");
        }
        const { data } = await this._vm.$http_session_manager.post(
          `/campaigns/${campaignId}/receiver`,
          payload
        );
        dispatch("receivers/get", campaignId);
        return data;
      } catch (err) {
        throw err;
      }
    },
    "receivers/update": async function ({ state, dispatch }, payload) {
      try {
        const campaignId = state.selectedCampaign._id;
        if (!campaignId) {
          throw new Error("No Campaign Selected");
        }
        const { data } = await this._vm.$http_session_manager.put(
          `/campaigns/${campaignId}/receivers/${payload.id}/update`,
          {
            name: payload.name,
          }
        );
        dispatch("receivers/get", campaignId);
        return data;
      } catch (err) {
        throw err;
      }
    },
    "receivers/delete": async function ({}, id) {
      try {
        await this._vm.$http_session_manager.delete(`/receivers/${id}`);
        return true;
      } catch (err) {
        throw err;
      }
    },

    "receivers/delete/single": async function ({ dispatch, state }, id) {
      try {
        const campaignId = state.selectedCampaign._id;
        if (!campaignId) {
          throw new Error("No Campaign Selected");
        }
        await this._vm.$http_session_manager.delete(
          `/campaigns/${campaignId}/receivers/${id}`
        );
        dispatch("receivers/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "receivers/sync/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_session_manager.post(`/receivers/${id}/sync`);
        dispatch("receivers/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "receivers/delete/multiple": async function ({ dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("receivers/delete", payload[i].id);
          } catch (err) {
            dispatch("setLoader", false);
            throw err;
          }
          if (i === payload.length - 1) return dispatch("receivers/get");
        }
      } catch (err) {
        throw err;
      }
    },
    "receivers/set": function ({ commit }, data) {
      commit("receivers/set", data);
      return data;
    },
    "receivers/select": function ({ commit }, data) {
      commit("receivers/select", data);
    },
  },
};
